export default __webpack_public_path__ + "static/bluecross-blueshield-da14f47229684ca85a0577454a40d88e.svg";